import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { LoginService } from '../../services/login.service';
import { TariffService } from '../../services/tariff.service';
import { ModalComponent } from 'src/app/core/components/modal/modal.component';
import { EntityListRefresh } from 'src/app/core/services/entity-list.refresh';
import { UINotificationService } from 'src/app/core/services/ui-notification.service';
import { NotificationType } from 'src/app/core/models/ui-notification.model';

@Component({
  selector: 'app-create-tariff',
  templateUrl: './create-tariff.component.html',
  styleUrls: ['./create-tariff.component.css']
})
export class CreateTariffComponent implements OnInit {

  form = new FormGroup({});
  langs = [
    { 'lang': 'cs', 'title': 'Česky' },
    { 'lang': 'en', 'title': 'Anglicky' },
    { 'lang': 'de', 'title': 'Německy' }
  ];

  constructor(
    private loginService: LoginService,
    private tariffService: TariffService,
    private tariffListRefresh: EntityListRefresh,
    private uiNotificationService: UINotificationService
  ) { }

  ngOnInit() {
    this.form.addControl('code', new FormControl('', Validators.required));
    this.form.addControl('maxLifts', new FormControl(0, Validators.required));
    this.form.addControl('maxUsers', new FormControl(0, Validators.required));
    this.form.addControl('maxLogDays', new FormControl(1, Validators.required));
    this.form.addControl('lang', new FormControl(this.langs[0], Validators.required));
    this.form.addControl('title', new FormControl('', Validators.required));

    this.form.controls['lang'].disable();
  }

  close(modal: ModalComponent) {
    modal.closeModal(null);
  }

  onSubmit(modal: ModalComponent) {
    if (this.form.valid && this.loginService.isSuperadmin()) {
      const tariffLang = [
        { twoLetterISOLanguageName: 'cs', title: this.form.get('title').value },
        { twoLetterISOLanguageName: 'de', title: this.form.get('title').value },
        { twoLetterISOLanguageName: 'en', title: this.form.get('title').value }
      ];

      this.tariffService.create({
        code: this.form.get('code').value,
        maxLifts: this.form.get('maxLifts').value,
        maxUsers: this.form.get('maxUsers').value,
        maxLogDays: this.form.get('maxLogDays').value,
        language: tariffLang
      }).subscribe(() => {
        this.tariffListRefresh.refresh('tariff');
        this.uiNotificationService.add({
          type: NotificationType.Info,
          message: 'Tarif byl vytvořen'
        });
        modal.closeModal(null);
      });
    }
  }
}
